import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { FINANCE_YEARS, FINANCE_REVENUE, FINANCE_PROFIT_RATE } from '../data/mockData';

// 区块7：营收与利润率组合图（柱状+折线）
export default function ChartComboFinance() {
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '五年营收预测与净利润率趋势',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 22, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: ['营业收入', '净利润率'],
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    grid: { left: '3%', right: '4%', bottom: '10%', top: '16%', containLabel: true },
    xAxis: {
      type: 'category',
      data: FINANCE_YEARS,
      axisLine: { lineStyle: { color: '#475569' } },
      axisLabel: { color: '#e2e8f0', fontSize: 15, fontWeight: 'bold' },
    },
    yAxis: [
      {
        type: 'value',
        name: '营业收入（万元）',
        nameTextStyle: { color: '#94a3b8', fontSize: 14 },
        axisLine: { lineStyle: { color: '#475569' } },
        axisLabel: { color: '#94a3b8', fontSize: 13 },
        splitLine: { lineStyle: { color: 'rgba(255,255,255,0.08)' } },
      },
      {
        type: 'value',
        name: '净利润率',
        nameTextStyle: { color: '#94a3b8', fontSize: 14 },
        axisLabel: { color: '#94a3b8', fontSize: 13, formatter: '{value}%' },
        splitLine: { show: false },
      },
    ],
    series: [
      {
        name: '营业收入',
        type: 'bar',
        data: FINANCE_REVENUE,
        itemStyle: {
          color: {
            type: 'linear',
            x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [
              { offset: 0, color: '#fbbf24' },
              { offset: 1, color: '#b45309' },
            ],
          },
          borderRadius: [8, 8, 0, 0],
        },
        barWidth: '40%',
        label: {
          show: true,
          position: 'top',
          formatter: '{c}万',
          color: '#fbbf24',
          fontSize: 14,
          fontWeight: 'bold',
        },
        animationDuration: 1500,
      },
      {
        name: '净利润率',
        type: 'line',
        yAxisIndex: 1,
        data: FINANCE_PROFIT_RATE,
        itemStyle: { color: '#06b6d4' },
        lineStyle: { width: 4 },
        symbol: 'circle',
        symbolSize: 10,
        label: {
          show: true,
          formatter: '{c}%',
          color: '#06b6d4',
          fontSize: 14,
          fontWeight: 'bold',
        },
        animationDuration: 1500,
        animationDelay: 300,
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 480 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
